export default __webpack_public_path__ + "assets/marketBatchUpload.6bcc46.png";